import type { ReservationItem } from '@/root/shared-types/reservation/reservation-types'
import { isPromotionItem } from '@/root/shared-helpers/reservation/reservation-item-filters'

interface ReservationItemCount {
  passengers: number
  residentPassengers: number
  vehicles: number
  residentVehicles: number
  bicycles: number
  isResident: boolean
}

export function countReservationItems(items: ReservationItem[], sailPackageSeqN?: number): ReservationItemCount {
  let passengers = 0
  let residentPassengers = 0
  let vehicles = 0
  let residentVehicles = 0
  let bicycles = 0
  let isResident = false

  for (const item of items) {
    if (sailPackageSeqN != null && item.sailPackageSeqN !== sailPackageSeqN) continue
    if (isPromotionItem(item)) continue

    if (item.type === 'PASSENGER') {
      passengers += item.quantity

      if (item.resident) {
        residentPassengers += item.quantity
        isResident = true
      }
    } else if (item.type === 'VEHICLE') {
      if (item.priceCategorySubType === 'BICYCLE') {
        bicycles += item.quantity
      } else {
        vehicles += item.quantity

        if (item.resident) {
          residentVehicles += item.quantity
        }
      }
    }
  }

  return { passengers, residentPassengers, vehicles, residentVehicles, bicycles, isResident }
}
